<!-- Information and terms -->
<!-- Orange box -->
<div class="bp-modal-body-section mod-eid-verification mod-middle-pt">
	@if (!isSolarisVerification) {
		<div class="verification-modal-eid-image">
			<img [src]="logoUrl" [alt]="'logo_alt_text' | translate" />
		</div>
	}
	@if (!isSolarisVerification) {
		<div class="verification-modal-eid-warning color-text warning">
			<div class="pb-10 font-bold">{{ "eid_data_box_title" | translate }}</div>
			@for (number of getReminderNumbers(); track number) {
				<div>{{ "eid_data_box_item_" + number | translate }}</div>
			}
			<div class="pt-10" [innerHTML]="'eid_data_box_item_4' | translate"></div>
		</div>
	}
</div>
@if (!isSolarisVerification) {
	<!-- Terms and Conditions -->
	@for (term of getVerificationTerms().terms; track term; let last = $last) {
		<div class="verification-modal-eid-switch">
			<div left>
				<div class="font-size-15 large-weight pb-10">{{ term.getTitleKey() | translate }}</div>
				<div class="description">
					<div class="font-size-13 info-color"
					>{{ term.getInfoKey() | translate }}
						<a class="hyperlink" [href]="getSupportLink()" target="_blank">{{ term.getLink() | translate }}</a>
					</div>
					<bp-switch [model]="getVerificationTerms()" field="{{ term.getName() }}"> </bp-switch>
				</div>
			</div>
		</div>
		<div [ngClass]="{ 'verification-modal-eid-seperator': !last }"></div>
	}
}

<div class="bp-modal-body-section">
	<button
		class="btn btn-primary verification-modal-eid-button"
		[ngClass]="{ disabled: isTermsButtonDisabled() }"
		(click)="onContinueClick()">
		{{ "save_and_continue" | translate }}
	</button>
	@if (isSolarisVerification) {
		<a class="solaris-troubleshoot-link link" [href]="getSolarisSupportLink()" target="_blank">
			Any problem with Solaris?
		</a>
	}
</div>